export * from './ironhack-logo-link';
